import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';




const SELECTOR = '.organism-vertical-tabs-text-image';



class OrganismVerticalTabsTextImage {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$tabNavigation = this._$element.find('.molecule-vertical-tab-navigation').first();
			this._$tabContentWrapper = this._$element.find('.tab-content-wrapper').first();

			this._prime();
		}

		return $element;
	}



	_prime() {
		let vpWidth = window.innerWidth || $(window).width();

		if (vpWidth >= BREAKPOINT_DESKTOP && !this._$tabNavigation.find('.tab-link').hasClass('active')) {
			this._setFirstItemActive();
		}

		this._initTabNavigation();
		this._initCollapsible();

		$(window).on('breakpointchange.app', (e, oldBreakpoint, newBreakpoint) => {
			if(newBreakpoint === 'large') {
				this._setFirstItemActive();
			}
		});
	}



	_setFirstItemActive() {
		this._$tabNavigation.find('.tab-link').removeClass('active');
		this._$tabNavigation.find('.tab-link').first().addClass('active');
		this._$tabContentWrapper.find('.molecule-vertical-tab-content').removeClass('active');
		this._$tabContentWrapper.find('.molecule-vertical-tab-content').first().addClass('active');
	}



	_initCollapsible() {
		let styleResetTimer = $.schedule(1, $.noop);

		this._$tabContentWrapper.find('.molecule-vertical-tab-content').children('.collapse-button')
			.on('click', function () {
				let	$parent = $(this).parent(),
					$content = $(this).siblings('.content-body').first(),
					contentHeight = 0;

				if( !$parent.hasClass('active') ) {
					$content.css('height', 'auto');
				}

				contentHeight = $content.outerHeight();

				if( !$parent.hasClass('active') ) {
					$content.css('height','0');
				} else {
					$content.css('height', contentHeight);
				}

				$parent.addClass('collapsible-collapsing');

				$.schedule(25, function () {
					if( !$parent.hasClass('active') ) {
						$content.css('height', contentHeight);
					} else {
						$content.css('height', '0');
					}

					$parent.toggleClass('active');

					styleResetTimer = $.reschedule(styleResetTimer, 250, function () {
						$parent.removeClass('collapsible-collapsing');
						$content.css('height', '');
					});
				});
			})
		;
	}


	_initTabNavigation() {
		this._$tabNavigation.find('.tab-link').on('click', (event) => {
			let currentIndex = $(event.currentTarget).index();

			this._$tabNavigation.find('.tab-link').removeClass('active');
			$(event.currentTarget).addClass('active');

			this._$tabContentWrapper.find('.molecule-vertical-tab-content').removeClass('active');
			this._$tabContentWrapper.find('.molecule-vertical-tab-content')
				.eq(currentIndex)
				.addClass('active')
				.stop(true)
				.css({opacity : 0.0})
				.animate({opacity : 1.0}, 500);
		});
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismVerticalTabsTextImage(app, $this));
	});

	return $elements;
}